import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c440228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BotToken__in" }
const _hoisted_2 = { class: "BotToken__actions" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Нажмите на мессенджер, чтобы перейти к боту ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Нажмите, чтобы перейти к боту ")

import { computed, watch } from "vue";

import { useStore } from "@/use/useStore";
import { useAsync } from "@/use/useAsync";
import { useTokens } from "@/use/useTokens";

import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiTitle from "@/plugins/ui/components/typography/UiTitle.vue";

import logoMax from "@/assets/images/MAX-logo.svg";
import logoTelegram from "@/assets/images/t-logo.svg";
// import logoVk from "@/assets/images/vk-logo.svg";

interface BotConfig {
  id: string;
  label: string;
  logo: string;
  buildURL: (token: string) => string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BotToken',
  setup(__props) {

const BOTS: BotConfig[] = [
  {
    id: "max",
    label: "MAX",
    logo: logoMax,
    buildURL: (token) => `https://max.ru/id281103167666_bot?start=${token}`,
  },
  // {
  //   id: "telegram",
  //   label: "Telegram",
  //   logo: logoTelegram,
  //   buildURL: (token) => `tg://resolve?domain=PioneerNotifyBot&start=${token}`,
  // },
  // {
  //   id: "vk",
  //   label: "VK",
  //   logo: logoVk,
  //   buildURL: (token) => `vk://resolve?domain=PioneerNotifyBot&start=${token}`,
  // },
];

const { currentUser } = useStore();
const { telegramToken, fetchTelegramToken } = useTokens();

useAsync(fetchTelegramToken, true);
watch(currentUser, fetchTelegramToken);

const token = computed(() => telegramToken.value?.value || "");
const timeout = computed(() => telegramToken.value?.timeout || 0);

const botLinks = computed(() =>
  BOTS.map((bot) => ({
    ...bot,
    url: bot.buildURL(token.value),
  })),
);

const hasMultipleBots = computed(() => BOTS.length > 1);

function openBot(url: string) {
  window.open(url, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiCard, null, {
    header: _withCtx(() => [
      _createVNode(UiHeader, {
        title: "Подключить уведомления",
        description: _unref(hasMultipleBots) ? 'Выберите мессенджер' : undefined
      }, null, 8, ["description"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(UiTitle, {
          level: "2",
          weight: "bold",
          class: "BotToken__token"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(token)), 1)
          ]),
          _: 1
        }),
        _createVNode(UiCaption, {
          level: "2",
          class: "BotToken__timeout"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(timeout)) + " сек. ", 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(botLinks), (bot) => {
          return (_openBlock(), _createElementBlock("div", {
            key: bot.id,
            class: _normalizeClass(["BotToken__action", { 'BotToken__action--single': !_unref(hasMultipleBots) }]),
            onClick: ($event: any) => (openBot(bot.url))
          }, [
            _createElementVNode("img", {
              src: bot.logo,
              class: "BotToken__action-icon"
            }, null, 8, _hoisted_4),
            _createVNode(UiCaption, {
              level: "2",
              class: "BotToken__action-label"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(bot.label), 1)
              ]),
              _: 2
            }, 1024)
          ], 10, _hoisted_3))
        }), 128))
      ]),
      _createVNode(UiCaption, {
        level: "3",
        class: "BotToken__help"
      }, {
        default: _withCtx(() => [
          (_unref(hasMultipleBots))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_6
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})